
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/about-our-posps",
      function () {
        return require("private-next-pages/about/about-our-posps/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/about-our-posps"])
      });
    }
  